import { render, staticRenderFns } from "./courseTeacherSelect.vue?vue&type=template&id=ffd06524"
import script from "./courseTeacherSelect.vue?vue&type=script&lang=js"
export * from "./courseTeacherSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports